// extracted by mini-css-extract-plugin
export default {"modal-search":"Modal_modal-search__ZKGmk","modal":"Modal_modal__qt-B9"};